module.exports = __webpack_public_path__ + "img/logo2.fd9a7431.png";